<template>
    <div class="p-bench-panel" :class="{ 'l-bench-overlay': overlay }" :style="{ borderTopColor: team.color }">
        <!-- the whole header closes the panel, not only the X -->
        <div class="p-bench-panel__head p-bench-panel__head--toggle" role="button" title="Close" @click="$emit('close')">
            <span>
                <span class="p-bench-panel__title">Bench</span>
                <span class="p-bench-panel__team">{{ team.name }}</span>
            </span>
            <v-btn icon small title="Close" @click.stop="$emit('close')">
                <v-icon small>mdi-close</v-icon>
            </v-btn>
        </div>
        <div v-if="!team.bench.length" class="p-court-empty">
            No players on the bench
        </div>
        <div v-else class="p-bench-grid" :class="{ 'l-bench-grid': overlay }">
            <div
                v-for="item in team.bench"
                :key="`bench-${item.player.id}`"
                class="p-bench-card"
                :class="{ 'p-bench-card--unavailable': !item.available, 'p-bench-card--selected': selectedPlayerId === item.player.id }"
                @click="$emit('player-click', item.player)"
            >
                <div class="p-bench-card__photo">
                    <v-icon color="grey"> mdi-account </v-icon>
                    <span class="p-bench-card__jersey" :style="{ backgroundColor: team.color, color: team.textColor }">{{ item.jersey }}</span>
                </div>
                <div class="p-bench-card__name">{{ item.player.name }}</div>
                <div class="p-bench-card__surname">{{ item.player.surname }}</div>
                <div v-if="!item.available" class="p-bench-card__reason">
                    <v-icon x-small color="red"> mdi-alert-circle </v-icon>
                    {{ item.reasons.join(', ') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Expanded bench of one team; overlay = bottom sheet over the content (tablet layout)
    export default {
        name: 'StatsBenchPanel',
        props: {
            team: {
                type: Object,
                required: true
            },
            overlay: {
                type: Boolean,
                default: false
            },
            // "select first" mode: highlights the selected player
            selectedPlayerId: {
                type: [Number, String],
                default: null
            }
        }
    }
</script>
